import React from "react";
import { skeletonContainerStyle, skeletonStyle, subSkeletonStyle } from "./MetricValueSkeleton.css";

export const MetricValueSkeleton = () => {
  return (
    <div className={skeletonContainerStyle}>
      <div className={skeletonStyle} />
      <div className={subSkeletonStyle} />
    </div>
  );
};
